import {CatalogRootFlexLayoutStoreContext, VipFlexLayoutTabStore, VipFlexLayoutTabStoreContext, MaybePopoverWrappedFlexTabButton} from '@stores/catalog/flexLayout'
import {classNames, React} from '@api'
import {Actions, CLASSES, I18nLabel, ICloseType, ITabButtonProps, Rect, TabButtonStore, TabButtonStoreContext} from '@flexlayout'
import {useStores, useVipLocalStore} from '@modules'
import {observer, useAsObservableSource} from '@api'
import { ITitleObject } from './Layout'

/** @hidden @internal */
export const BorderButton = observer<ITabButtonProps & { border: string; }>(function BorderButton(props) {
    const { layout, node, iconFactory, titleFactory, icons } = props,
      selected = /*props.selected ||*/ node.selectedInBorder,
      selfRef = React.useRef<HTMLDivElement | null>(null),
      {flexLayout} = useStores(),
      obsProps = useAsObservableSource(props),
      store = useVipLocalStore((s) => new TabButtonStore(s, obsProps)),
      {layout: {getClassName: cm}, className} = store

    const onMouseDown = (event: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>) => {
        if ((event as React.MouseEvent<HTMLDivElement>).button === 2) return // Todo - what about the touch event with 2 fingers?

        const message = layout.i18nName(I18nLabel.Move_Tab, node.displayName);
        props.layout.dragStart(event, message, node, node.isEnableDrag, onClick, flexLayout.onDoubleClick_forTabNode(node) as any);
    };

    const onClick = (e) => {
        layout.doAction(Actions.selectTab(node.id));
    };

    const isClosable = () => {
        const closeType = node.closeType;
        if (selected || closeType === ICloseType.Always) {
            return true;
        }
        if (closeType === ICloseType.Visible) {
            // not selected but x should be visible due to hover
            if (window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
                return true;
            }
        }
        return false;
    };

    const onClose = (event: React.MouseEvent<HTMLDivElement>) => {
        if (isClosable()) {
            layout.doAction(Actions.deleteTab(node.id));
        } else {
            onClick(event);
        }
    };

    const onCloseMouseDown = (event: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>) => {
        event.stopPropagation();
    };

    React.useLayoutEffect(() => {
        updateRect();
    }, []);

    const updateRect = () => {
        // record position of tab in border
        const clientRect = layout.domRect;
        const r = selfRef.current!.getBoundingClientRect();
        node._setTabRect(new Rect(r.left - clientRect.left, r.top - clientRect.top, r.width, r.height));
    }

    let leadingContent = iconFactory ? iconFactory(node) : undefined;
    let titleContent: React.ReactNode = node.name;
    let name = node.name;

    function isTitleObject(obj: any): obj is ITitleObject {
        return obj.titleContent !== undefined 
      }

    if (titleFactory !== undefined) {
        const titleObj = titleFactory(node);
        if (titleObj !== undefined) {
            if (typeof titleObj === "string") {
                titleContent = titleObj as string;
                name = titleObj as string;
            } else if (isTitleObject(titleObj)) {
                titleContent = titleObj.titleContent;
                name = titleObj.name;
            } else {
                titleContent = titleObj;
            }
        }
    }

    if (typeof leadingContent === undefined && typeof node.icon !== undefined) {
        leadingContent = <img src={node.icon} alt="leadingContent" />;
    }

    let buttons: any[] = [];

    // allow customization of leading contents (icon) and contents
    const renderState = { leading: leadingContent, content: titleContent, name, buttons };
    layout.customizeTab(node, renderState);

    const content = <div className={cm(CLASSES.FLEXLAYOUT__BORDER_BUTTON_CONTENT)}>{renderState.content}</div>;
    const leading = <div className={cm(CLASSES.FLEXLAYOUT__BORDER_BUTTON_LEADING)}>{renderState.leading}</div>;

    if (node.isEnableClose) {
        const closeTitle = layout.i18nName(I18nLabel.Close_Tab);
        buttons.push(
            <div key="close" title={closeTitle} className={cm(CLASSES.FLEXLAYOUT__BORDER_BUTTON_TRAILING)} onMouseDown={onCloseMouseDown} onClick={onClose} onTouchStart={onCloseMouseDown}>
                {icons?.close}
            </div>
        );
    }

    const tabMenuStoreProps = useAsObservableSource({flexNode: node}),
      tabStore = useVipLocalStore(s => new VipFlexLayoutTabStore(s, tabMenuStoreProps)),
      disabled = flexLayout.isDisabled(node)

    return (
      <TabButtonStoreContext.Provider value={store}>
          <VipFlexLayoutTabStoreContext.Provider value={tabStore}>
              <CatalogRootFlexLayoutStoreContext.Provider value={node.catalogRoot}>

              <MaybePopoverWrappedFlexTabButton node={node}>
        <div ref={selfRef} className={className}
             data-id={node.id}
             data-disabled={disabled}
             onDoubleClick={flexLayout.onDoubleClick_forTabNode(node)}
             onMouseDown={onMouseDown}
             onContextMenu={flexLayout.onContextMenu_forTabNode(node)}
             onTouchStart={onMouseDown}>
            {leading}
            {content}
            {buttons}
        </div>
    </MaybePopoverWrappedFlexTabButton>
              </CatalogRootFlexLayoutStoreContext.Provider>
          </VipFlexLayoutTabStoreContext.Provider>
      </TabButtonStoreContext.Provider>)
})


// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexlayout-react/src/view/BorderButton.tsx